//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ActionButtons',

  props: {
    okText: {
      type: String,
      default() {
        return 'OK'
      }
    },

    cancelText: {
      type: String,
      default() {
        return 'Cancel'
      }
    },

    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },

    noMargin: {
      type: Boolean,
      default() {
        return false
      }
    }
  }
}
